import {
  GET_TRANSACTIONS,
  GET_TRANSACTIONS_ERROR,
  GET_TRANSACTIONS_EMPTY,
  LOADER,
  LOADER_BUREAU,
  GET_SUSPICIOUS_ACTIVITY,
  GET_BOUNCED_CHEQUE,
  EMPTY_DATA,
  GET_SUSPICIOUS_ACTIVITY_ERROR,
  GET_SUSPICIOUS_ACTIVITY_EMPTY,
  GET_BOUNCED_CHEQUE_EMPTY,
  GET_BOUNCED_CHEQUE_ERROR,
  GET_ACCOUNT_OVERVIEW,
  GET_ACCOUNT_OVERVIEW_ERROR,
  GET_ACCOUNT_OVERVIEW_EMPTY,
  GET_DAILY_BALANCE,
  GET_DAILY_BALANCE_ERROR,
  GET_DAILY_BALANCE_EMPTY,
  GET_TRANSACTION_SUMMARY,
  GET_TRANSACTION_SUMMARY_ERROR,
  GET_TRANSACTION_SUMMARY_EMPTY,
  GET_CLOSING_BALANCE,
  GET_CLOSING_BALANCE_ERROR,
  GET_CLOSING_BALANCE_EMPTY,
  GET_CIRCULAR_TRANSACTIONS,
  GET_CIRCULAR_TRANSACTIONS_EMPTY,
  GET_CIRCULAR_TRANSACTIONS_ERROR,
  GET_INTRA_BANK_FUND_TRANSFER,
  GET_INTRA_BANK_FUND_TRANSFER_EMPTY,
  GET_INTRA_BANK_FUND_TRANSFER_ERROR,
  GET_CASH_FLOW,
  GET_CASH_FLOW_ERROR,
  GET_CASH_FLOW_EMPTY,
  GET_RECCURING_PAYMENTS,
  GET_RECCURING_PAYMENTS_EMPTY,
  GET_RECCURING_PAYMENTS_ERROR,
  GET_RECCURING_DEPOSITS,
  GET_RECCURING_DEPOSITS_ERROR,
  GET_RECCURING_DEPOSITS_EMPTY,
  GET_EMI_DEPOSITS,
  GET_EMI_DEPOSITS_EMPTY,
  GET_EMI_DEPOSITS_ERROR,
  GET_LOANS,
  GET_LOANS_ERROR,
  GET_LOANS_EMPTY,
  GET_SALARY,
  GET_SALARY_ERROR,
  GET_SALARY_EMPTY,
  GET_CATEGORIES,
  GET_CATEGORIES_ERROR,
  GET_CATEGORIES_EMPTY,
  GET_BIZ_CASHFLOW,
  GET_BIZ_CASHFLOW_ERROR,
  GET_BIZ_CASHFLOW_EMPTY,
  GET_COUNTER_PARTY,
  GET_COUNTER_PARTY_ERROR,
  GET_COUNTER_PARTY_EMPTY,
  GET_ODCC_UTILIZATION,
  GET_ODCC_UTILIZATION_ERROR,
  GET_ODCC_UTILIZATION_EMPTY,
  GET_TAGS,
  GET_TAGS_ERROR,
  GET_TAGS_EMPTY,
  GET_CATOPTIONS,
  GET_CATOPTIONS_ERROR,
  GET_CATOPTIONS_EMPTY,
  GET_BOUNCED_CHEQUE_STATE,
  GET_CATEGORIES_STATE,
  GET_RECURRING_PAYMENTS_STATE,
  GET_RECURRING_DEPOSITS_STATE,
  GET_EMI_PAYMENTS_STATE,
  GET_LOANS_STATE,
  GET_SALARY_STATE,
  GET_TXNS_STATE,
  GET_SUSPICIOUS_STATE,
  GET_TXNS_SUMMARY_STATE,
  GET_COUNTER_PARTY_STATE,
  GET_ODCCUTILIZATION_STATE,
  EDIT_TRANSACTION,
  EDIT_TRANSACTION_ERROR,
  ACCOUNT_TAGS,
  ACCOUNT_CATEGORIES,
  EDIT_TRANSCTION_FOR_LOCAL,
  ACCOUNT_FETCH_USER,
  EMPTY_DATA_TXNS_COUNT,
  NEW_ADDED_TXNS,
  EDIT_TRANSACTION_RESET,
  GET_TRANSACTIONS_WITH_INDEXING,
  TXNS_REF_FLAG,
  GET_COUNTER_PARTY_MONTHLY,
  GET_MONTHLY_COUNTERPARTY_STATE,
  GET_COUNTER_PARTY_MONTHLY_ERROR,
  GET_COUNTER_PARTY_MONTHLY_WITH_PAGINATION,
  ACCOUNT_ID_FOR_RE_ANALYSIS,
  ACCOUNT_TAB_PERSIST,
  ACCOUNT_TAB_PERSIST_EMPTY,
  GET_DUPLICATE_TXNS,
  GET_DUPLICATE_TXNS_ERROR,
  GET_DUPLICATE_TXNS_STATE,
  GET_SUMMARY,
  GET_SUMMARY_ERROR,
  GET_SUMMARY_EMPTY,
  GET_CASH_FLOW_ANALYSIS,
  GET_CASH_FLOW_ANALYSIS_ERROR,
  GET_CASH_FLOW_ANALYSIS_EMPTY,
  GET_LOAN_ANALYSIS,
  GET_LOAN_ANALYSIS_ERROR,
  GET_LOAN_ANALYSIS_EMPTY,
  GET_BANKS,
  GET_BUREAU_DATA_ANALYSIS,
  GET_BUREAU_DATA_ANALYSIS_ERROR,
  GET_BUREAU_DATA_ANALYSIS_EMPTY,
  GET_ACCOUNT_TABSCOUNT,
  GET_ACCOUNT_TABSCOUNT_ERROR,
  GET_UPI_TXNS,
  GET_UPI_TXNS_ERROR,
  GET_UPI_TXNS_EMPTY,
  GET_AML_ANALYSIS_DATA,
  GET_AML_ANALYSIS_DATA_ERROR,
  HIDE_LOADER
} from 'src/actions/accountAnalysisAction';
import produce from 'immer';
import { initialSuspiciousCollapsesState } from 'src/constantsMessage';

const bouncedChequeStateInitialValus = {
  outwardChequeOrderBy: '',
  outwardChequeOrder: 'desc',
  inwardChequeOrderBy: '',
  inwardChequeOrder: 'desc',
  inwardChequeOpen: false,
  outwardChequeOpen: false
};

const categoriesStateIntialValue = {
  inwardCategorieOpen: false,
  outwardCategorieOpen: false,
  Inflow: {},
  Outflow: {},
  InflowPagination: {
    page: 0,
    rowsPerPage: 100
  },
  OutflowPagination: {
    page: 0,
    rowsPerPage: 100
  }
};

const patternStateInitialValue = {
  page: 0,
  rowsPerPage: 100,
  orderBy: 'transactionCount',
  order: 'desc'
};

const counterpartyInitialState = {
  orderCredit: 'desc',
  pageCredit: 0,
  rowsPerPageCredit: 100,
  orderByCredit: 'amount',
  creditSearchQuery: '',

  orderDebit: 'desc',
  orderByDebit: 'amount',
  pageDebit: 0,
  rowsPerPageDebit: 100,
  debitSearchQuery: ''
};

const odccUtilizationState = {
  page: 0,
  rowsPerPage: 100,
  orderBy: '',
  order: 'desc'
};
const initialTxnsState = {
  selectedFilters: [],
  page: 1,
  rowsPerPage: 100,
  orderBy: 'transaction_date',
  order: 'asc',
  scrollPx: 0
};

const monthlyCounterPartyState = {
  page: 1,
  rowsPerPage: 100,
  orderBy: '',
  order: 'asc',
  txnsType: 'Show All',
  query: ''
};

const duplicateTxnsInitialState = {
  page: 1,
  rowsPerPage: 100
};

const initialState = {
  transactions: null,
  allBanks: [],
  transactionsError: null,
  suspiciousActivity: null,
  suspiciousActivityError: null,
  bouncedChequeError: null,
  overview: null,
  tabCounts: null,
  circularTransactions: null,
  circularTransactionsError: null,
  intraBankTransfer: null,
  intraBankTransferError: null,
  cashFlow: null,
  cashFlowError: null,
  cashFlowAnalysis: null,
  cashFlowAnalysisError: null,
  loanAnalysis: null,
  loanAnalysisError: null,
  overviewError: null,
  tabCountsError: null,
  bouncedCheque: null,
  dailyBalance: null,
  dailyBalanceError: null,
  transactionSummary: null,
  transactionSummaryError: null,
  closingBalance: null,
  closingBalanceError: null,
  recurringPayments: null,
  recurringPaymentsError: null,
  recurringDeposits: null,
  recurringDepositsError: null,
  emiDeposits: null,
  emiDepositsError: null,
  loans: null,
  loansError: null,
  salary: null,
  salaryError: null,
  categories: null,
  categoriesError: null,
  bizCashFlow: null,
  bizCashFlowError: null,
  counterParty: null,
  counterPartyError: null,
  odccUtilization: null,
  odccUtilizationError: null,
  tagOptions: null,
  tagOptionsError: null,
  categoriesOptions: null,
  categoriesOptionsError: null,
  isLoading: false,
  bouncedChequeState: bouncedChequeStateInitialValus,
  categoriesState: categoriesStateIntialValue,
  recurringPaymentsState: patternStateInitialValue,
  recurringDepositsState: patternStateInitialValue,
  EMIPaymentsState: patternStateInitialValue,
  loansState: patternStateInitialValue,
  salaryState: patternStateInitialValue,
  txnsState: initialTxnsState,
  suspiciousState: initialSuspiciousCollapsesState,
  txnsSummaryState: {},
  counterPartyState: counterpartyInitialState,
  odccUtilizationState: odccUtilizationState,
  editTransaction: false,
  accountTags: null,
  accountCategories: null,
  editTransactionForLocal: null,
  accountModifiedUser: [],
  newAddedTransaction: null,
  txnsRefFlag: null,
  monthlyCounterParty: null,
  monthlyCounterPartyError: null,
  monthlyCounterPartyState: monthlyCounterPartyState,
  monthlyCounterPartyToggle: false,
  monthlyCounterPartyData: null,
  accountIdForReAnalysis: null,
  accountTabPersist: {},
  duplicateTxns: null,
  duplicateTxnsError: null,
  duplicateTxnsState: duplicateTxnsInitialState,
  bureauDataAnalysis: null,
  bureauDataAnalysisError: null,
  isLoadingBureau: false,
  upiTxnsAnalysis: null,
  upiTxnsAnalysisError: null,
  amlAnalysis: null,
  amlAnalysisError: null
};

const accountAnalysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER: {
      return produce(state, draft => {
        draft.isLoading = true;
        draft.isLoadingBureau = true;
      });
    }
    case LOADER_BUREAU: {
      return produce(state, draft => {
        draft.isLoadingBureau = true;
      });
    }
    case GET_TRANSACTIONS: {
      const acountData = action.payload;
      return produce(state, draft => {
        draft.transactions = acountData;
        draft.transactionsError = null;
        draft.isLoading = false;
      });
    }
    case GET_BANKS: {
      const bankData = action.payload;
      return produce(state, draft => {
        draft.allBanks = bankData;
      });
    }
    case GET_TRANSACTIONS_WITH_INDEXING: {
      const acountData = action.payload;
      return produce(state, draft => {
        draft.transactions = acountData;
        draft.transactionsError = null;
        draft.isLoading = true;
      });
    }
    case GET_TRANSACTIONS_ERROR: {
      const acountData = action.payload;
      return produce(state, draft => {
        draft.transactionsError = acountData;
        draft.isLoading = false;
      });
    }
    case GET_TRANSACTIONS_EMPTY: {
      return produce(state, draft => {
        draft.transactionsError = null;
      });
    }
    case GET_SUSPICIOUS_ACTIVITY: {
      return produce(state, draft => {
        draft.suspiciousActivity = action.payload;
        draft.suspiciousActivityError = null;
        draft.isLoading = false;
      });
    }
    case GET_SUSPICIOUS_ACTIVITY_ERROR: {
      return produce(state, draft => {
        draft.suspiciousActivityError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SUSPICIOUS_ACTIVITY_EMPTY: {
      return produce(state, draft => {
        draft.suspiciousActivityError = null;
        draft.suspiciousActivity = null;
      });
    }
    case GET_BOUNCED_CHEQUE: {
      return produce(state, draft => {
        draft.bouncedCheque = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_BOUNCED_CHEQUE_ERROR: {
      return produce(state, draft => {
        draft.bouncedChequeError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_BOUNCED_CHEQUE_EMPTY: {
      return produce(state, draft => {
        draft.bouncedCheque = null;
        draft.bouncedChequeError = null;
      });
    }
    case GET_ACCOUNT_OVERVIEW: {
      return produce(state, draft => {
        draft.overview = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_ACCOUNT_OVERVIEW_ERROR: {
      return produce(state, draft => {
        draft.overviewError = action.payload;
        draft.isLoading = false;
      });
    }

    case GET_ACCOUNT_TABSCOUNT: {
      return produce(state, draft => {
        draft.tabCounts = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_ACCOUNT_TABSCOUNT_ERROR: {
      return produce(state, draft => {
        draft.tabCountsError = action.payload;
        draft.isLoading = false;
      });
    }

    case GET_ACCOUNT_OVERVIEW_EMPTY: {
      return produce(state, draft => {
        draft.overviewError = null;
        draft.overview = null;
      });
    }
    case GET_DAILY_BALANCE: {
      return produce(state, draft => {
        draft.dailyBalance = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_DAILY_BALANCE_ERROR: {
      return produce(state, draft => {
        draft.dailyBalanceError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_DAILY_BALANCE_EMPTY: {
      return produce(state, draft => {
        draft.dailyBalanceError = null;
        draft.dailyBalance = null;
      });
    }
    case GET_TRANSACTION_SUMMARY: {
      return produce(state, draft => {
        draft.transactionSummary = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_TRANSACTION_SUMMARY_ERROR: {
      return produce(state, draft => {
        draft.transactionSummaryError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_TRANSACTION_SUMMARY_EMPTY: {
      return produce(state, draft => {
        draft.transactionSummaryError = null;
        draft.transactionSummary = null;
      });
    }

    case GET_CLOSING_BALANCE: {
      return produce(state, draft => {
        draft.closingBalance = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_CLOSING_BALANCE_ERROR: {
      return produce(state, draft => {
        draft.closingBalanceError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_CLOSING_BALANCE_EMPTY: {
      return produce(state, draft => {
        draft.closingBalanceError = null;
        draft.closingBalance = null;
      });
    }

    case GET_CIRCULAR_TRANSACTIONS: {
      return produce(state, draft => {
        draft.circularTransactions = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_CIRCULAR_TRANSACTIONS_ERROR: {
      return produce(state, draft => {
        draft.circularTransactionsError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_CIRCULAR_TRANSACTIONS_EMPTY: {
      return produce(state, draft => {
        draft.circularTransactionsError = null;
        draft.circularTransactions = null;
        draft.isLoading = false;
      });
    }
    case GET_INTRA_BANK_FUND_TRANSFER: {
      return produce(state, draft => {
        draft.intraBankTransfer = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_INTRA_BANK_FUND_TRANSFER_ERROR: {
      return produce(state, draft => {
        draft.intraBankTransferError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_INTRA_BANK_FUND_TRANSFER_EMPTY: {
      return produce(state, draft => {
        draft.intraBankTransferError = null;
        draft.intraBankTransfer = null;
        draft.isLoading = false;
      });
    }
    case GET_CASH_FLOW: {
      return produce(state, draft => {
        draft.cashFlow = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_CASH_FLOW_ERROR: {
      return produce(state, draft => {
        draft.cashFlowError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_CASH_FLOW_EMPTY: {
      return produce(state, draft => {
        draft.cashFlow = null;
        draft.cashFlowError = null;
        draft.isLoading = false;
      });
    }
    case GET_RECCURING_PAYMENTS: {
      return produce(state, draft => {
        draft.recurringPayments = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_RECCURING_PAYMENTS_ERROR: {
      return produce(state, draft => {
        draft.recurringPaymentsError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_RECCURING_PAYMENTS_EMPTY: {
      return produce(state, draft => {
        draft.recurringPayments = null;
        draft.recurringPaymentsError = null;
        draft.isLoading = false;
      });
    }
    case GET_RECCURING_DEPOSITS: {
      return produce(state, draft => {
        draft.recurringDeposits = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_RECCURING_DEPOSITS_ERROR: {
      return produce(state, draft => {
        draft.recurringDepositsError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_RECCURING_DEPOSITS_EMPTY: {
      return produce(state, draft => {
        draft.recurringDeposits = null;
        draft.recurringDepositsError = null;
        draft.isLoading = false;
      });
    }
    case GET_EMI_DEPOSITS: {
      return produce(state, draft => {
        draft.emiDeposits = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_EMI_DEPOSITS_ERROR: {
      return produce(state, draft => {
        draft.emiDepositsError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_EMI_DEPOSITS_EMPTY: {
      return produce(state, draft => {
        draft.emiDeposits = null;
        draft.emiDepositsError = null;
        draft.isLoading = false;
      });
    }
    case GET_LOANS: {
      return produce(state, draft => {
        draft.loans = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_LOANS_ERROR: {
      return produce(state, draft => {
        draft.loansError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_LOANS_EMPTY: {
      return produce(state, draft => {
        draft.loans = null;
        draft.loansError = null;
        draft.isLoading = false;
      });
    }
    case GET_SALARY: {
      return produce(state, draft => {
        draft.salary = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SALARY_ERROR: {
      return produce(state, draft => {
        draft.salaryError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SALARY_EMPTY: {
      return produce(state, draft => {
        draft.salary = null;
        draft.salaryError = null;
        draft.isLoading = false;
      });
    }
    case GET_CATEGORIES: {
      return produce(state, draft => {
        draft.categories = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_CATEGORIES_ERROR: {
      return produce(state, draft => {
        draft.categoriesError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_CATEGORIES_EMPTY: {
      return produce(state, draft => {
        draft.categories = null;
        draft.categoriesError = null;
        draft.isLoading = false;
      });
    }
    case GET_BIZ_CASHFLOW: {
      return produce(state, draft => {
        draft.bizCashFlow = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_BIZ_CASHFLOW_ERROR: {
      return produce(state, draft => {
        draft.bizCashFlowError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_BIZ_CASHFLOW_EMPTY: {
      return produce(state, draft => {
        draft.bizCashFlow = null;
        draft.bizCashFlowError = null;
        draft.isLoading = false;
      });
    }
    case GET_COUNTER_PARTY: {
      return produce(state, draft => {
        draft.counterParty = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_COUNTER_PARTY_ERROR: {
      return produce(state, draft => {
        draft.counterPartyError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_COUNTER_PARTY_EMPTY: {
      return produce(state, draft => {
        draft.counterParty = null;
        draft.counterPartyError = null;
        draft.isLoading = false;
      });
    }
    case GET_ODCC_UTILIZATION: {
      return produce(state, draft => {
        draft.odccUtilization = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_ODCC_UTILIZATION_ERROR: {
      return produce(state, draft => {
        draft.odccUtilizationError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_ODCC_UTILIZATION_EMPTY: {
      return produce(state, draft => {
        draft.odccUtilization = null;
        draft.odccUtilizationError = null;
        draft.isLoading = false;
      });
    }
    case GET_TAGS: {
      return produce(state, draft => {
        draft.tagOptions = action.payload;
        // draft.isLoading = false;
      });
    }
    case GET_TAGS_ERROR: {
      return produce(state, draft => {
        draft.tagOptionsError = action.payload;
        // draft.isLoading = false;
      });
    }
    case GET_TAGS_EMPTY: {
      return produce(state, draft => {
        draft.tagOptions = null;
        draft.tagOptionsError = null;
        // draft.isLoading = false;
      });
    }
    case GET_CATOPTIONS: {
      return produce(state, draft => {
        draft.categoriesOptions = action.payload;
        // draft.isLoading = false;
      });
    }
    case GET_CATOPTIONS_ERROR: {
      return produce(state, draft => {
        // draft.isLoading = false;
      });
    }
    case GET_CATOPTIONS_EMPTY: {
      return produce(state, draft => {
        draft.categoriesOptions = null;
        draft.categoriesOptionsError = null;
        // draft.isLoading = false;
      });
    }
    case GET_BOUNCED_CHEQUE_STATE: {
      return produce(state, draft => {
        draft.bouncedChequeState = action.payload;
      });
    }
    case GET_CATEGORIES_STATE: {
      return produce(state, draft => {
        draft.categoriesState = action.payload;
      });
    }
    case GET_RECURRING_PAYMENTS_STATE: {
      return produce(state, draft => {
        draft.recurringPaymentsState = action.payload;
      });
    }
    case GET_RECURRING_DEPOSITS_STATE: {
      return produce(state, draft => {
        draft.recurringDepositsState = action.payload;
      });
    }
    case GET_EMI_PAYMENTS_STATE: {
      return produce(state, draft => {
        draft.EMIPaymentsState = action.payload;
      });
    }
    case GET_LOANS_STATE: {
      return produce(state, draft => {
        draft.loansState = action.payload;
      });
    }
    case GET_SALARY_STATE: {
      return produce(state, draft => {
        draft.salaryState = action.payload;
      });
    }
    case GET_TXNS_STATE: {
      return produce(state, draft => {
        draft.txnsState = action.payload;
      });
    }
    case GET_SUSPICIOUS_STATE: {
      return produce(state, draft => {
        draft.suspiciousState = action.payload;
      });
    }
    case GET_TXNS_SUMMARY_STATE: {
      return produce(state, draft => {
        draft.txnsSummaryState = action.payload;
      });
    }
    case GET_COUNTER_PARTY_STATE: {
      return produce(state, draft => {
        draft.counterPartyState = action.payload;
      });
    }
    case GET_ODCCUTILIZATION_STATE: {
      return produce(state, draft => {
        draft.odccUtilizationState = action.payload;
      });
    }
    case EDIT_TRANSACTION: {
      return produce(state, draft => {
        draft.editTransaction = action.payload;
        draft.editTransactionForLocal = null;
      });
    }
    case EDIT_TRANSACTION_ERROR: {
      return produce(state, draft => {
        draft.editTransaction = action.payload;
        draft.isLoading = false;
      });
    }
    case NEW_ADDED_TXNS: {
      return produce(state, draft => {
        draft.newAddedTransaction = action.payload;
        draft.isLoading = false;
      });
    }
    case EDIT_TRANSACTION_RESET: {
      return produce(state, draft => {
        draft.newAddedTransaction = false;
        draft.editTransaction = false;
        draft.isLoading = action.payload ? true : false;
      });
    }
    case EDIT_TRANSCTION_FOR_LOCAL: {
      return produce(state, draft => {
        draft.editTransactionForLocal = action.payload;
        draft.isLoading = false;
      });
    }
    case ACCOUNT_TAGS: {
      return produce(state, draft => {
        draft.accountTags = action.payload;
      });
    }
    case ACCOUNT_CATEGORIES: {
      return produce(state, draft => {
        draft.accountCategories = action.payload;
      });
    }
    case ACCOUNT_FETCH_USER: {
      return produce(state, draft => {
        draft.accountModifiedUser = action.payload;
      });
    }
    case ACCOUNT_ID_FOR_RE_ANALYSIS: {
      return produce(state, draft => {
        draft.accountIdForReAnalysis = action.payload;
        draft.isLoading = false;
      });
    }
    case EMPTY_DATA_TXNS_COUNT: {
      return produce(state, draft => {
        draft.isLoading = false;
        draft.suspiciousActivity = null;
        draft.categories = null;
        draft.categoriesError = null;
        draft.cashFlow = null;
        draft.cashFlowError = null;
        draft.cashFlowAnalysis = null;
        draft.cashFlowAnalysisError = null;
        draft.loanAnalysis = null;
        draft.loanAnalysisError = null;
        draft.counterParty = null;
        draft.counterPartyError = null;
        draft.recurringPayments = null;
        draft.recurringPaymentsError = null;
        draft.recurringDeposits = null;
        draft.recurringDepositsError = null;
        draft.emiDeposits = null;
        draft.emiDepositsError = null;
        draft.loans = null;
        draft.loansError = null;
        draft.salary = null;
        draft.salaryError = null;
        draft.monthlyCounterParty = null;
      });
    }
    case TXNS_REF_FLAG: {
      return produce(state, draft => {
        draft.txnsRefFlag = action.payload;
      });
    }
    case GET_COUNTER_PARTY_MONTHLY: {
      return produce(state, draft => {
        draft.monthlyCounterParty = action.payload;
        draft.monthlyCounterPartyError = null;
        draft.accountIdForReAnalysis = null;
        // draft.isLoading = false;
      });
    }
    case GET_MONTHLY_COUNTERPARTY_STATE: {
      return produce(state, draft => {
        draft.monthlyCounterPartyState = action.payload;
      });
    }
    case GET_COUNTER_PARTY_MONTHLY_ERROR: {
      return produce(state, draft => {
        draft.isLoading = false;
      });
    }
    case GET_COUNTER_PARTY_MONTHLY_WITH_PAGINATION: {
      return produce(state, draft => {
        draft.monthlyCounterPartyData = action.payload;
        draft.isLoading = false;
        draft.monthlyCounterPartyError = null;
      });
    }

    case GET_SUMMARY: {
      return produce(state, draft => {
        draft.summary = action.payload;
        draft.isLoading = false;
      });
    }

    case GET_SUMMARY_ERROR: {
      return produce(state, draft => {
        draft.summaryError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SUMMARY_EMPTY: {
      return produce(state, draft => {
        draft.summary = null;
        draft.summaryError = null;
        draft.isLoading = false;
      });
    }

    case GET_BUREAU_DATA_ANALYSIS: {
      return produce(state, draft => {
        draft.bureauDataAnalysis = action.payload;
        draft.isLoadingBureau = false;
      });
    }
    case GET_BUREAU_DATA_ANALYSIS_ERROR: {
      return produce(state, draft => {
        draft.bureauDataAnalysisError = action.payload;
        draft.isLoadingBureau = false;
      });
    }
    case GET_BUREAU_DATA_ANALYSIS_EMPTY: {
      return produce(state, draft => {
        draft.bureauDataAnalysis = null;
        draft.bureauDataAnalysisError = null;
        draft.isLoadingBureau = false;
      });
    }
    case GET_UPI_TXNS: {
      return produce(state, draft => {
        draft.upiTxnsAnalysis = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_UPI_TXNS_ERROR: {
      return produce(state, draft => {
        draft.upiTxnsAnalysisError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_UPI_TXNS_EMPTY: {
      return produce(state, draft => {
        draft.upiTxnsAnalysis = null;
        draft.upiTxnsAnalysisError = null;
        draft.isLoading = false;
      });
    }

    case EMPTY_DATA: {
      return produce(state, draft => {
        draft.isLoading = false;
        draft.suspiciousActivity = null;
        draft.transactions = null;
        draft.transactionsError = null;
        draft.suspiciousActivityError = null;
        draft.overview = null;
        draft.tabCounts = null;
        draft.bouncedCheque = null;
        draft.bouncedChequeError = null;
        draft.dailyBalance = null;
        draft.dailyBalanceError = null;
        draft.transactionSummary = null;
        draft.transactionSummaryError = null;
        draft.closingBalance = null;
        draft.closingBalanceError = null;
        draft.circularTransactions = null;
        draft.circularTransactionsError = null;
        draft.intraBankTransfer = null;
        draft.intraBankTransferError = null;
        draft.cashFlow = null;
        draft.cashFlowError = null;
        draft.upiTxnsAnalysis = null;
        draft.upiTxnsAnalysisError = null;
        draft.cashFlowAnalysis = null;
        draft.cashFlowAnalysisError = null;
        draft.loanAnalysis = null;
        draft.loanAnalysisError = null;
        draft.recurringPayments = null;
        draft.recurringPaymentsError = null;
        draft.recurringDeposits = null;
        draft.recurringDepositsError = null;
        draft.emiDeposits = null;
        draft.emiDepositsError = null;
        draft.loans = null;
        draft.loansError = null;
        draft.salary = null;
        draft.salaryError = null;
        draft.categories = null;
        draft.categoriesError = null;
        draft.bizCashFlow = null;
        draft.bizCashFlowError = null;
        draft.counterParty = null;
        draft.counterPartyError = null;
        draft.odccUtilization = null;
        draft.odccUtilizationError = null;
        draft.tagOptions = null;
        draft.tagOptionsError = null;
        draft.categoriesOptions = null;
        draft.categoriesOptionsError = null;
        draft.summary = null;
        draft.summaryError = null;
        draft.bureauDataAnalysis = null;
        draft.bureauDataAnalysisError = null;
        draft.isLoadingBureau = false;
        draft.bouncedChequeState = bouncedChequeStateInitialValus;
        draft.categoriesState = categoriesStateIntialValue;
        draft.recurringPaymentsState = patternStateInitialValue;
        draft.recurringDepositsState = patternStateInitialValue;
        draft.EMIPaymentsState = patternStateInitialValue;
        draft.loansState = patternStateInitialValue;
        draft.salaryState = patternStateInitialValue;
        draft.suspiciousState = initialSuspiciousCollapsesState;
        draft.txnsSummaryState = {};
        draft.counterPartyState = counterpartyInitialState;
        draft.odccUtilizationState = odccUtilizationState;
        draft.editTransaction = false;
        draft.accountTags = null;
        draft.accountCategories = null;
        draft.editTransactionForLocal = null;
        draft.accountModifiedUser = [];
        draft.newAddedTransaction = null;
        draft.txnsRefFlag = null;
        draft.txnsState = {
          ...initialTxnsState,
          rowsPerPage: state.txnsState.rowsPerPage
        };
        draft.monthlyCounterParty = null;
        draft.monthlyCounterPartyError = null;
        draft.monthlyCounterPartyState = {
          ...monthlyCounterPartyState,
          rowsPerPage: state.monthlyCounterPartyState.rowsPerPage,
          txnsType: state.monthlyCounterPartyState.txnsType
        };
        draft.monthlyCounterPartyData = null;
        draft.accountIdForReAnalysis = null;
        draft.duplicateTxns = null;
        draft.duplicateTxnsError = null;
        draft.duplicateTxnsState = duplicateTxnsInitialState;
      });
    }

    case ACCOUNT_TAB_PERSIST: {
      return produce(state, draft => {
        draft.accountTabPersist = {
          ...state.accountTabPersist,
          [action.payload1]: action.payload
        };
      });
    }

    case ACCOUNT_TAB_PERSIST_EMPTY: {
      return produce(state, draft => {
        draft.accountTabPersist = {};
      });
    }

    case GET_DUPLICATE_TXNS: {
      return produce(state, draft => {
        draft.duplicateTxns = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_DUPLICATE_TXNS_ERROR: {
      return produce(state, draft => {
        draft.duplicateTxnsError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_DUPLICATE_TXNS_STATE: {
      return produce(state, draft => {
        draft.duplicateTxnsState = action.payload;
      });
    }

    case GET_CASH_FLOW_ANALYSIS: {
      return produce(state, draft => {
        draft.cashFlowAnalysis = action.payload;
        draft.isLoading = false;
      });
    }

    case GET_CASH_FLOW_ANALYSIS_ERROR: {
      return produce(state, draft => {
        draft.cashFlowAnalysisError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_CASH_FLOW_ANALYSIS_EMPTY: {
      return produce(state, draft => {
        draft.cashFlowAnalysis = null;
        draft.cashFlowAnalysisError = null;
        draft.isLoading = false;
      });
    }

    case GET_LOAN_ANALYSIS: {
      return produce(state, draft => {
        draft.loanAnalysis = action.payload;
        draft.isLoading = false;
      });
    }

    case GET_LOAN_ANALYSIS_ERROR: {
      return produce(state, draft => {
        draft.loanAnalysisError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_LOAN_ANALYSIS_EMPTY: {
      return produce(state, draft => {
        draft.loanAnalysis = null;
        draft.loanAnalysisError = null;
        draft.isLoading = false;
      });
    }

    case GET_AML_ANALYSIS_DATA: {
      return produce(state, draft => {
        draft.amlAnalysis = action.payload;
        draft.isLoading = false;
        draft.amlAnalysisError = null;
      });
    }

    case GET_AML_ANALYSIS_DATA_ERROR: {
      return produce(state, draft => {
        draft.amlAnalysisError = action.payload;
        draft.isLoading = false;
        draft.amlAnalysis = null;
      });
    }

    case HIDE_LOADER: {
      return produce(state, draft => {
        draft.isLoading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default accountAnalysisReducer;
